// Safe Swiper init for Safari/iOS compatibility
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    document.querySelectorAll(".card__media-swiper").forEach(function (el) {
      if (typeof Swiper === "undefined") return;
      new Swiper(el, {
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: el.querySelector(".swiper-pagination"),
          dynamicBullets: true,
        },
        navigation: {
          nextEl: el.querySelector(".swiper-button-next"),
          prevEl: el.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          0: {
            navigation: { enabled: false },
            pagination: { enabled: false },
          },
          768: {
            navigation: { enabled: true },
            pagination: { enabled: false },
          },
        },
      });
    });

    // Mobile swiper
    if (window.innerWidth < 767) {
      var mobileEl = document.querySelector(".mobile-swiper");
      if (mobileEl && typeof Swiper !== "undefined") {
        new Swiper(mobileEl, {
          pagination: { el: ".swiper-pagination" },
        });
      }
    }
  }, 500);
});
